import React, {useState, useEffect} from "react";
import {createTheme, ThemeProvider, CssBaseline, Box} from "@mui/material";
import Header from "./Header";
import MusicContainer from "./MusicContainer";
import MusicPlayer from "./MusicPlayer";
import MusicImporter from "./MusicImporter";
import Footer from "./Footer";
import "./App.css";

const theme = createTheme({
    palette: {
        primary: {
            main: "#b7e5ff"
        },
        secondary: {
            main: "#f472d0"
        },
        text: {
            primary: "#000",
            secondary: "#fff"
        }
    },
    typography: {
        fontFamily: "Nunito"
    }
});

const style = {
    width: "100vw",
    height: "100vh",
    display: "flex",
    flexDirection: "column"
};

function App(){
    const urls = ["songs/Teri Galliyan - Ek Villain - Ankit Tiwari.mp3", "songs/Bekhayali - Kabir Singh - Sachet Tandon.mp3", "songs/Toota Jo Kabhi Tara - A Flying Jatt - Atif Aslam, Sumedha K.mp3", "songs/Mere Naam Tu - Zero - Abhay Jodhpurkar.mp3", "songs/Mai Agar Kahoon - Om Shanti Om - Sonu Nigam, Shreya Ghosal.mp3", "songs/Gerua - Dilwale - Pritam.mp3", "songs/Titli - Chennai Express - Chinmayi Sripaada, Gopi Sunder.mp3", "songs/Galti - Vishal Mishra.mp3", "songs/Kesariya - Brahmstra - Pritam, Arijit Singh.mp3", "songs/Jab Tak - M.S Dhoni The Untold Story - Armaan Malik.mp3", "songs/Chaleya - Jawan - Arijit Singh, Shilpa R.mp3", "songs/Pehle Bhi Main - Animal - Vishal Mishra.mp3", "songs/Khoya Hai - Bahubali - M.M Kreem, Manoj M.mp3", "songs/Ishq Wala Love Full Video - Student Of The Year - Salim Merchant, Neeti Mohan, Shekhar Ravjian.mp3", "songs/O Maahi - Dunki - Arijit Singh.mp3"];

    const thumbnails = ["https://imgs.search.brave.com/WGgz22WG8w84a3j26e9k1c5VDZ2eym8gZ8dYMg43OOQ/rs:fit:500:0:0/g:ce/aHR0cHM6Ly9wcmV2/aWV3LnJlZGQuaXQv/cmV3YXRjaGVkLWVr/LXZpbGxhaW4tdG9k/YXktYW5kLXN0aWxs/LWNhbm5vdC1iZWxp/ZXZlLXJpdGVzaC12/MC1rNnJvYWZvMGFl/NGIxLmpwZz9hdXRv/PXdlYnAmcz01OGJh/ZGRiZDQ2NTdmMWVm/ZTBhYWI1NTYyNTdm/ODU1MTgyZDdmZjNj", "https://imgs.search.brave.com/Vp5P1QVDWnoPC4PkkNoGcGQOlzJphvmO49nVeqXSEaU/rs:fit:500:0:0/g:ce/aHR0cHM6Ly93YWxs/cGFwZXJjYXZlLmNv/bS93cC93cDQ0MDEx/ODQuanBn", "https://imgs.search.brave.com/hxtaMZTA7GNDX38NqdXXCHGYaJH2-p31PCis_mIs-CI/rs:fit:500:0:0/g:ce/aHR0cHM6Ly9tLm1l/ZGlhLWFtYXpvbi5j/b20vaW1hZ2VzL00v/TVY1Qk1EWmpOVGRo/T0dNdFl6WmhaUzAw/WW1JeUxUaGpaRGN0/TVRobVlUUmtZalZt/TkRKbFhrRXlYa0Zx/Y0dkZVFYVnlPREU1/TnpFM09URUAuanBn", "https://imgs.search.brave.com/7VgXaZnjckL3se0Wws8JKrtbCHHmbETSKsWdbXc-5FY/rs:fit:860:0:0/g:ce/aHR0cHM6Ly91cGxv/YWQud2lraW1lZGlh/Lm9yZy93aWtpcGVk/aWEvZW4vdGh1bWIv/ZS9lNi9aZXJvX29m/ZmljaWFsX3Bvc3Rl/ci5qcGcvMjIwcHgt/WmVyb19vZmZpY2lh/bF9wb3N0ZXIuanBn", "https://imgs.search.brave.com/WHSrNcwJlXEZRge6JW2qSp1doX7Xg0bwU_IM7LBx_t0/rs:fit:500:0:0/g:ce/aHR0cHM6Ly9pLnBp/bmltZy5jb20vb3Jp/Z2luYWxzLzQ4LzEw/Lzc0LzQ4MTA3NGJh/N2M3MGU0NWI2YmE5/Yzc2ZTI0OTZhNzIw/LmpwZw", "https://imgs.search.brave.com/UFjGeSxOWJhNTTPdO295-ynvRAu9jwl8rTwyOTTaiYo/rs:fit:500:0:0/g:ce/aHR0cHM6Ly9pbWcu/aW5kaWFmb3J1bXMu/Y29tL21lZGlhLzQ4/MHgwLzM4LzM5ODUt/ZGlsd2FsZS1tb3Zp/ZS1wb3N0ZXIuanBn", "https://imgs.search.brave.com/erkh9t3sOwHmfwVtVD3pF-K5L_v0qON5h0j19umtEUU/rs:fit:500:0:0/g:ce/aHR0cDovL3d3dy5p/bXBhd2FyZHMuY29t/L2ludGwvaW5kaWEv/MjAxMy9wb3N0ZXJz/L2NoZW5uYWlfZXhw/cmVzc194bGcuanBn", "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTNh0r959IXyeYVVE7ByU3ddi_jCnx_31exU5QK_dgDNg&s", "https://m.media-amazon.com/images/M/MV5BMDEyNjA0MWItY2IxMi00YTZjLTkxOGItNWIwOGQ2OTZmNTg2XkEyXkFqcGdeQXVyMTYyNjAzOTUx._V1_FMjpg_UX1000_.jpg", "https://imgs.search.brave.com/2rijPU309dLHlQxF3_ulVDZzpyHTBiMVOXrp9XaG1zI/rs:fit:500:0:0/g:ce/aHR0cHM6Ly9zdGF0/aWMta29pbW9pLmFr/YW1haXplZC5uZXQv/d3AtY29udGVudC9u/ZXctZ2FsbGVyaWVz/LzIwMTYvMDcvbS1z/LWRob25pLXRoZS11/bnRvbGQtc3Rvcnkt/cG9zdGVyLmpwZw", "https://imgs.search.brave.com/8h2VxY5vjM6da2hNZIswyUiewXRdAwfDyDm--qHb9Ac/rs:fit:500:0:0/g:ce/aHR0cHM6Ly9pLnBp/bmltZy5jb20vb3Jp/Z2luYWxzLzJjLzJl/L2UxLzJjMmVlMTMy/ZWY4ZDRiMWE3ODVj/Zjg1NjliNDg4MzI3/LmpwZw", "https://imgs.search.brave.com/fVfTfBClmgJDF2qV6A0YU9UOhJEY4U1CPe-VhrxqL14/rs:fit:500:0:0/g:ce/aHR0cHM6Ly9zdGF0/aWMxLnRyaWJ1dGUu/Y2EvcG9zdGVyLzY2/MHg5ODAvYW5pbWFs/LTE3NDE1MC5qcGc", "https://imgs.search.brave.com/YVc7sWPUICxlrt8JAlMYvxTpj_57YFy198nvLm_QRm0/rs:fit:500:0:0/g:ce/aHR0cHM6Ly93YWxs/cGFwZXJjYXZlLmNv/bS93cC93cDQwMjc0/MTUuanBn", "https://imgs.search.brave.com/_DAQBOrDGX8_GyGKqYlAA9gXpd6N7CCEJluurA37cwc/rs:fit:500:0:0/g:ce/aHR0cHM6Ly9jZG4u/d2FsbHBhcGVyc2Fm/YXJpLmNvbS85Ni8z/OS9RbVNYaVkuanBn", "https://imgs.search.brave.com/q70aalryobaxawQodfRnINXMVj2DqwEHsZQKICCupoM/rs:fit:500:0:0/g:ce/aHR0cHM6Ly93d3cu/cGlua3ZpbGxhLmNv/bS9waWNzLzI0NXgz/NTAvMTYwNzYxMjkz/MV9kdW5raS1wXzIw/MjMwOS5qcGc"];

    const defaultThumbnail = "https://imgs.search.brave.com/Rl4x4svUEiizaPARuxO_qJv0iDTejCmsWmOH9j3Vxe8/rs:fit:860:0:0/g:ce/aHR0cHM6Ly90My5m/dGNkbi5uZXQvanBn/LzA0LzU0LzY2LzEy/LzM2MF9GXzQ1NDY2/MTI3N19OdFFZTThv/SnEyd096WTFYOVk4/MUZsRmEwNkRWaXBW/RC5qcGc";

    const [tabValue, setTabValue] = useState(0);

    const [songs, setSongs] = useState([]);

    const [currentSong, setCurrentSong] = useState({});

    const [playing, setPlaying] = useState(false);

    const [loopState, setLoopState] = useState("loop");

    useEffect(() => {
        if (currentSong.audio){
            if (loopState === "loop"){
                currentSong.audio.onended = () => {
                    currentSong.audio.currentTime = 0;

                    currentSong.audio.pause();

                    if (songs[currentSong.number + 1]){
                        setCurrentSong(songs[currentSong.number + 1]);
                    }
                    else{
                        setCurrentSong(songs[0]);
                    }

                    setTabValue(1);
                }
            }
            else if (loopState === "loopOne"){
                currentSong.audio.onended = () => {
                    currentSong.audio.play();
                }
            }
            else if (loopState === "shuffle"){
                currentSong.audio.onended = () => {
                    currentSong.audio.currentTime = 0;

                    currentSong.audio.pause();

                    setCurrentSong(songs[Math.floor(Math.random() * songs.length)]);
                    
                    setTabValue(1);
                }
            }
            else{
                currentSong.audio.onended = () => {
                    setPlaying(false);
                }
            }
        }
    }, [loopState, currentSong]);

    useEffect(() => {
        Promise.all(urls.map(async (url, index) => {
            const song = {
                number: index,
                audio: await new Audio(url),
                name: url.split("/").pop().replace(/\.[^/.]+$/, ""),
                thumbnail: thumbnails[index]
            };

            setSongs((oldSongs) => {
                if (index === 0){
                    setCurrentSong(song);
                }

                return [...oldSongs, song];
            });
        }));

        window.addEventListener("contextmenu", (event) => {
            event.preventDefault();
        });
    }, []);

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline/>

            <Box style={style}>
                <Header tabValue={tabValue} setTabValue={setTabValue}/>

                {(tabValue === 0) &&
                    <MusicContainer songs={songs} currentSong={currentSong} setCurrentSong={setCurrentSong} setTabValue={setTabValue} setPlaying={setPlaying}/>
                }

                {(tabValue === 1) &&
                    <MusicPlayer currentSong={currentSong} setCurrentSong={setCurrentSong} playing={playing} setPlaying={setPlaying} loopState={loopState} setLoopState={setLoopState} songs={songs}/>
                }
   
                {(tabValue === 2) &&
                    <MusicImporter songs={songs} thumbnails={thumbnails} defaultThumbnail={defaultThumbnail} setSongs={setSongs} setTabValue={setTabValue}/>
                }

                <Footer/>
            </Box>
        </ThemeProvider>
    );
}

export default App;